import productConstants from '@utils/constants/product';

export function getTypesById(id) {
    return productConstants.TYPES.find((item) => item.id === id);
}
